module.exports = __webpack_public_path__ + "img/krindus-logo.3c3d79de.svg";